import React from 'react';
import { Box } from '@mui/material';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import { toastSuccess } from '@/styles/tokens';

// Іконка тосту успіху (Figma): біле коло 24px з галочкою кольору тосту.
export const ToastSuccessIcon: React.FC = () => (
  <Box
    sx={{
      width: 24,
      height: 24,
      p: '2px',
      borderRadius: '50%',
      bgcolor: toastSuccess.iconBg,
      color: toastSuccess.background,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
    }}
  >
    <CheckRoundedIcon sx={{ fontSize: 20 }} />
  </Box>
);
